import { ErrorsContextProvider, ValidationErrors } from 'components';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath, useLocation, useNavigate } from 'react-router';
import { Button, toast } from '@britishcouncil/react-admin';
import { useCallback, useEffect, useMemo } from 'react';
import { parseServerErrors } from 'utils';
import { lrwSessionStore } from 'store';

export const RemoveLrwSession = () => {
  const sessionId = useIntParam('sessionId');
  const location = useLocation();
  const { lrwSessionDetails, lrwSessions } = ROUTING_PATHS;
  const [removeSession, { isSuccess, error: removeError, isLoading: isConfirming, reset }] =
    lrwSessionStore.service.useRemoveLrwSessionMutation();
  const navigate = useNavigate();
  const errors = useMemo(() => parseServerErrors(removeError), [removeError]);

  const goToLrwSessions = useCallback(() => {
    navigate(generatePath(lrwSessions.absolutePath, { sessionId }));
  }, [navigate, lrwSessions.absolutePath, sessionId]);

  useEffect(() => {
    if (isSuccess) {
      toast({
        type: 'success',
        title: 'Success',
        message: 'LRW session removed',
      });
      goToLrwSessions();
      reset();
    }
  }, [goToLrwSessions, isSuccess, sessionId, reset]);

  return (
    <ErrorsContextProvider generalErrors={errors}>
      <Modal open size="tiny">
        <Modal.Header>Remove LRW session</Modal.Header>
        <Modal.Content>
          <ValidationErrors />
          <p>Would you like to remove this LRW session?</p>
        </Modal.Content>

        <Modal.Actions>
          <Link
            to={generatePath(lrwSessionDetails.absolutePath, { sessionId })}
            state={location.state}
          >
            <Button compact type="reset" secondary>
              Cancel
            </Button>
          </Link>

          <Button
            compact
            color="red"
            onClick={() => {
              removeSession({ lrwSessionId: sessionId });
            }}
            loading={isConfirming}
            disabled={isConfirming}
          >
            Remove
          </Button>
        </Modal.Actions>
      </Modal>
    </ErrorsContextProvider>
  );
};
